import { Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Stack, ThemeProvider, Typography } from '@mui/material';
import React, { useState } from 'react';
import moment from 'moment';
import DialogProvider, { useDialog } from './DialogProvider';
import theme from '../../themeContent';

// Períodos rápidos (substitui o date-picker Início/Fim — mais rápido).
const PERIODS = [
  { key: '1h', label: '1 hora', amount: 1, unit: 'hours' },
  { key: '7d', label: '7 dias', amount: 7, unit: 'days' },
  { key: '30d', label: '30 dias', amount: 30, unit: 'days' },
];

function _DialogGraph({ handleClose, open, children, title }) {
  const { setQuery, setSearch, search } = useDialog()
  const [period, setPeriod] = useState('7d')

  const pick = (p) => {
    setPeriod(p.key)
    setQuery({
      start: moment().subtract(p.amount, p.unit).toISOString(),
      end: moment().toISOString(),
    })
    setSearch(true)
  }

  return (
    <ThemeProvider theme={theme}>
      <Dialog open={open} onClose={handleClose} maxWidth={false}>
        <DialogTitle id="form-dialog-title">
          <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} gap={2}>
            <Typography variant="h6" align="center">{title}</Typography>
            <Stack direction="row" spacing={1}>
              {PERIODS.map(p => (
                <Chip
                  key={p.key}
                  label={p.label}
                  size="small"
                  disabled={search}
                  color={period === p.key ? 'primary' : 'default'}
                  variant={period === p.key ? 'filled' : 'outlined'}
                  onClick={() => pick(p)}
                />
              ))}
            </Stack>
          </Box>
        </DialogTitle>
        <DialogContent>
          {children}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose} variant="outlined" color="primary">
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
}

export default function (props) {
  return (

    <DialogProvider>
      <_DialogGraph {...props} />
    </DialogProvider>
  )
}